export enum CourseTypes {
    standard = 'standard',
    testSeries = 'testSeries',
    combo = 'combo' 
}